import React, { useRef, useState } from "react";
import { usePromiseEffect } from "../../../helpers/promiseEffect";
import { Col, Form, Offcanvas, Row } from "react-bootstrap";
import Select, { SingleValue } from "react-select";
import DesviacionService from "../../../services/DesviacionService";
import { ITipoCausaInmediata } from "../../../entities/ITipoCausaInmediata";
import ISearch from "../../../entities/helper/ISearch";
import { ROW_COUNT, ROW_COUNT_MAX } from "../../../helpers/variableHelper";
import { IComboboxOption } from "../../../entities/helper/IComboboxOption";
import UserPicker from "../../../controls/UserPicker";
import moment from "moment";
import IUserPickerValue from "../../../entities/helper/IUserPickerValue";
import ICurrentUser from "../../../entities/helper/ICurrentUser";
import { cognitoUserInfo } from "../../../helpers/userHelper";
import { IAddCausaInmediata, ICausaInmediata } from "../../../entities/ICausaInmediata";
import { E_EstadoCausa } from "../../../enums/E_EstadoCausa";
import { IActoCondicionSubestandar } from "../../../entities/IActoCondicionSubestandar";
import { dateFormatDiplay, dateFormatInputReference, shortDate } from "../../../helpers/dateHelper";
import { CellContext, createColumnHelper } from "@tanstack/react-table";
import { ITipo_Campo } from "../../../helpers/IFormHelper";
import IDocumentoDesviacion, { IAddDocumentosCausasEvidencias, ISearchDocsCausasEvidencias } from "../../../entities/IDocumentoDesviacion";
import { getFileName } from "../../../helpers/pathHelper";
import { ModalCausaObservaciones, ModalCausaRechazo, ModalConfirmacionCierre } from "./Modal/ModalCausaObservaciones";
import Swal, { SweetAlertResult } from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { ICausa, IDesviacion } from "../../../entities/IDesviacion";
import { E_EstadoFormCausaDesviacion } from "../../../enums/E_EstadoFormulario";
import Loading from "../../../cross/Loading";
import { AdminListaPagination, IPagination } from "../../../controls/AdminListaPagination";
import RenderTitle from "../../../controls/RenderTitle";
import RenderValue from "../../../controls/RenderValue";
import IAuditoria from "../../../entities/IAuditoria";
import { EnumEstadoDesviacion } from "../../../entities/helper/EnumEstadoDesviacion";
const MySwal = withReactContent(Swal);

interface IAgregarAnalisisCausalProps {
  token: string;
  idDesviacion: number;
  onClose: () => void;
  onSave: () => void;
  selectedAnalisisCausal?: ICausaInmediata | null;
  estadoForm: E_EstadoFormCausaDesviacion;
  isVistaDetallada?: boolean;
  isFlujoCorto?: boolean;
  is_Test?: boolean;
  docs?: Array<IDocumentoDesviacion>;
  addCausaInmediata?: IAddCausaInmediata;
  selectedAudit: IAuditoria | null;
}
export default function AgregarAnalisisCausalInmediato({
  token,
  idDesviacion,
  onClose,
  onSave,
  selectedAnalisisCausal,
  estadoForm,
  isVistaDetallada,
  isFlujoCorto,
  is_Test,
  docs,
  addCausaInmediata,
  selectedAudit,
}: IAgregarAnalisisCausalProps) {
  const [selectedAnalisisCausalState, setSelectedAnalisisCausalState] = useState<ICausaInmediata | null>(selectedAnalisisCausal || null);
  const [comboTCI, setComboTCI] = useState<Array<ITipoCausaInmediata>>([]);
  const totalPagesListDocumentos = useRef<number>(0);
  const [comboACS, setComboACS] = useState<Array<IActoCondicionSubestandar>>([]);
  const [selectedDesviacion, setSelectedDesviacion] = useState<IDesviacion | null>(null);
  const [valComboTCI, setValComboTCI] = useState<IComboboxOption | null>(
    selectedAnalisisCausal
      ? {
          label: selectedAnalisisCausal?.TIPO_CAUSA_INMEDIATA,
          value: selectedAnalisisCausal?.ID_TIPO_CAUSA_INMEDIATA.toString(),
        }
      : null
  );
  const [valComboACS, setvalComboACS] = useState<IComboboxOption | null>(
    selectedAnalisisCausal
      ? {
          label: selectedAnalisisCausal?.ACTO_CONDICION_SUBESTANDAR,
          value: selectedAnalisisCausal?.ID_ACTO_CONDICION_SUBESTANDAR.toString(),
        }
      : null
  );
  const refTxtAccion = React.createRef<HTMLTextAreaElement>();
  const [lenAccion, setLenAccion] = useState(0);
  const [valResponsable, setValResponsable] = useState<IUserPickerValue | null>(
    selectedAnalisisCausal
      ? {
          mail: selectedAnalisisCausal?.RESPONSABLE,
          name: selectedAnalisisCausal?.RESPONSABLE_DISPLAY,
        }
      : null
  );
  const refTxtFechaHasta = React.createRef<HTMLInputElement>();
  const refTxtFechaAccionRealizada = React.createRef<HTMLInputElement>();
  const refTxtDescripcionDocumento = React.createRef<HTMLTextAreaElement>();
  const refInputDocumento = React.createRef<HTMLInputElement>();
  const [currentUser, setCurrentUser] = useState<ICurrentUser>();
  const [arrErrorEmpty, setArrErrorEmpty] = useState<string[]>([]);
  const [listDocumentos, setListDocumentos] = useState<Array<IDocumentoDesviacion>>(docs ?? []);
  const [isSendingData, setIsSendingData] = useState(false);
  const [isUploadingDocs, setIsUploadingDocs] = useState(false);
  const component = (titulo: string) => {
    return <RenderTitle title={titulo} />;
  };

  const componentValue = (value: any) => {
    return <RenderValue value={value} />;
  };

  const componentEliminar = (info: any) => {
    return (
      <i
        data-testid="btneliminar"
        className="bi bi-trash iconSearch"
        title="Eliminar documento"
        onClick={() => {
          MySwal.fire({
            text: `¿Está seguro que desea eliminar el documento?`,
            icon: "question",
            confirmButtonText: "Aceptar",
            cancelButtonText: "Cancelar",
            showCloseButton: true,
            showCancelButton: true,
          }).then(async (result: SweetAlertResult) => {
            if (result.isConfirmed) {
              await DesviacionService.deleteDocumentoCausaEvidencia(token, info.row.original.ID);
              await loadDocumentos(selectedAnalisisCausalState?.ID);
            }
          });
        }}></i>
    );
  };

  const componentVer = (info: any) => {
    return (
      <i
        className="bi bi-search iconSearch"
        data-testid="btnver"
        title="Ver documento"
        onClick={() => {
          DesviacionService.getContenidoDocumentoAnalisCausal(token, info.row.original.URL);
        }}></i>
    );
  };

  const renderEstadoForm = () => {
    if (
      (selectedDesviacion?.RESPONSABLE_CIERRE && selectedDesviacion?.RESPONSABLE_CIERRE !== null) ||
      (selectedAudit?.AUDITORES_ACOMPANANTES && selectedAudit?.AUDITORES_ACOMPANANTES !== null)
    ) {
      return (
        selectedDesviacion?.RESPONSABLE_CIERRE === currentUser?.email ||
        isParticipatingAudit(selectedAudit?.AUDITORES_ACOMPANANTES, currentUser?.email)
      );
    } else {
      return selectedDesviacion?.RESPONSABLE_INVESTIGACION === currentUser?.email;
    }
  };

  const isParticipatingAudit = (users: string | undefined, emailUser: string | undefined) => {
    if (users !== undefined && users !== null) {
      let arrayUsers = users.split("; ");
      const result = arrayUsers.some((user) => user.trim() === emailUser);
      return result;
    }
    return false;
  };

  usePromiseEffect(async () => {
    let currUser = await cognitoUserInfo();
    setCurrentUser(currUser);
    if (idDesviacion) {
      let resultDesviacion = await DesviacionService.getDesvicacionByID(token, idDesviacion);
      setSelectedDesviacion(resultDesviacion);
    }
    await fillComboTCI();
    if (selectedAnalisisCausal?.ID_TIPO_CAUSA_INMEDIATA !== undefined) {
      await fillComboACS(selectedAnalisisCausal?.ID_TIPO_CAUSA_INMEDIATA.toString());
    }
    await loadDocumentos();
  }, []);
  const common: ISearch = {
    ORDENADOPOR: "TITULO",
    ORIENTACION: "ASC",
    PAGINA: 1,
    PAGINADO: ROW_COUNT_MAX,
  };

  const loadDocumentos = async (idCausa?: number) => {
    if (idCausa || selectedAnalisisCausal?.ID) {
      let resultDocumentos = is_Test
        ? { data: docs ?? [] }
        : await DesviacionService.getDocumentosCausasEvidencias(token, {
            ID_CAUSA: idCausa || (selectedAnalisisCausal?.ID as number),
            ID_DESVIACION: idDesviacion,
            ORDENADOPOR: "ID",
            ORIENTACION: "DESC",
            PAGINA: 1,
            PAGINADO: ROW_COUNT,
          });
      setListDocumentos(resultDocumentos.data);
      setLenAccion(selectedAnalisisCausal?.ACCION.length || 0);
    }
  };

  const fillComboTCI = async () => {
    const resultTCB = await DesviacionService.getListadoTiposCausaInmediata(token, { ...common, ACTIVO: true });
    setComboTCI(resultTCB);
    setComboACS([]);
  };

  const fillComboACS = async (comboTCI?: string) => {
    const resultFP = await DesviacionService.getListadoActoCondicionSubestandar(token, {
      ...common,
      ACTIVO: true,
      ID_TIPO_CAUSA: parseInt(comboTCI as string),
      ORDENADOPOR: "TITULO",
      ORIENTACION: "ASC",
      PAGINA: 1,
      PAGINADO: ROW_COUNT_MAX,
    });
    setComboACS(resultFP);
  };

  const validateForm = (value: IAddCausaInmediata, flagContinuar?: boolean) => {
    let errors = [];
    if (!value.ID_TIPO_CAUSA_INMEDIATA) {
      errors.push("ID_TIPO_CAUSA_INMEDIATA");
    }
    if (!value.ID_ACTO_CONDICION_SUBESTANDAR) {
      errors.push("ID_ACTO_CONDICION_SUBESTANDAR");
    }
    if (!value.ACCION) {
      errors.push("ACCION");
    }
    if (!value.RESPONSABLE && !isFlujoCorto) {
      errors.push("RESPONSABLE");
    }

    if (isFlujoCorto && listDocumentos.length === 0 && flagContinuar) {
      MySwal.fire({
        html: (
          <div>
            <h3>Error Ingreso de datos</h3>
            <p>Debe cargar al menos una evidencia</p>
          </div>
        ),
        icon: "warning",
        confirmButtonText: "Aceptar",
        showCloseButton: true,
        showCancelButton: false,
      });
      errors.push("ADJUNTOS_FLUJO_CORTO");
    }
    if (!isFlujoCorto && !moment(value.FECHA_HASTA).isValid()) {
      errors.push("FECHA_HASTA");
    }
    if (isFlujoCorto && !moment(value.FECHA_ACCION_REALIZADA).isValid()) {
      errors.push("FECHA_ACCION_REALIZADA");
    }

    setArrErrorEmpty(errors);

    return errors.length === 0;
  };

  const handleGuardarCausaInmediata = async (saveDoc?: boolean, accionRealizada?: boolean) => {
    const value: IAddCausaInmediata = {
      ID: selectedAnalisisCausalState?.ID,
      ID_DESVIACION: idDesviacion,
      ID_TIPO_CAUSA_INMEDIATA: parseInt(valComboTCI?.value as string),
      ID_ACTO_CONDICION_SUBESTANDAR: parseInt(valComboACS?.value as string),
      ID_ESTADO: !accionRealizada ? E_EstadoCausa.Asignada : E_EstadoCausa.AccionRealizada,
      ACCION: refTxtAccion.current?.value as string,
      RESPONSABLE: (isFlujoCorto ? selectedDesviacion?.RESPONSABLE_INVESTIGACION : valResponsable?.mail) as string,
      RESPONSABLE_DISPLAY: (isFlujoCorto ? selectedDesviacion?.RESPONSABLE_INVESTIGACION_DISPLAY : valResponsable?.name) as string,
      FECHA_ASIGNACION: new Date(),
      FECHA_HASTA: isFlujoCorto ? new Date(refTxtFechaAccionRealizada.current?.value as string) : new Date(refTxtFechaHasta.current?.value as string),
      FECHA_ACCION_REALIZADA: isFlujoCorto ? new Date(refTxtFechaAccionRealizada.current?.value as string) : null,
      FECHA_INGRESO_ACCION_REALIZADA: isFlujoCorto ? new Date() : null,
      FECHA_MODIFICACION: selectedAnalisisCausalState ? new Date() : null,
      AUTOR: currentUser?.email as string,
      AUTOR_DISPLAY: currentUser?.fullname as string,
      EDITOR: selectedAnalisisCausalState ? (currentUser?.email as string) : null,
      EDITOR_DISPLAY: selectedAnalisisCausalState ? (currentUser?.fullname as string) : null,
      RECHAZO: null,
      FECHA_CREACION: selectedAnalisisCausalState ? selectedAnalisisCausalState.FECHA_CREACION : new Date(),
    };
    if (validateForm(value, accionRealizada)) {
      setIsSendingData(true);
      const id = await DesviacionService.postCausaInmediata(token, value);
      if (!saveDoc) {
        onSave();
      } else {
        setSelectedAnalisisCausalState({
          ...value,
          ID: id,
          TIPO_CAUSA_INMEDIATA: valComboTCI?.label,
          ACTO_CONDICION_SUBESTANDAR: valComboACS?.label,
        } as any);
      }
      setIsSendingData(false);
      return id;
    } else {
      return null;
    }
  };

  const handleCerrarCausa = (estado: E_EstadoCausa) => {
    if (estado === E_EstadoCausa.AccionRealizada && listDocumentos.length === 0) {
      MySwal.fire({
        html: (
          <div>
            <h3>Error Ingreso de datos</h3>
            <p>Debe cargar al menos una evidencia</p>
          </div>
        ),
        icon: "warning",
        confirmButtonText: "Aceptar",
        showCloseButton: true,
        showCancelButton: false,
      });
      return;
    }

    let val: ICausa = {
      ID: selectedAnalisisCausal?.ID as number,
      EDITOR: currentUser?.email as string,
      EDITOR_DISPLAY: currentUser?.fullname as string,
      ID_DESVIACION: idDesviacion,
      ID_ESTADO: estado,
      REQUIERE_CAMBIO_ESTADO: true,
      FECHA_ACCION_REALIZADA: selectedAnalisisCausal?.FECHA_ACCION_REALIZADA,
      FECHA_INGRESO_ACCION_REALIZADA: selectedAnalisisCausal?.FECHA_INGRESO_ACCION_REALIZADA,
    };

    if (estado === E_EstadoCausa.CerradoObservacion) {
      ModalCausaObservaciones(async (observacion: string) => {
        val.CON_OBSERVACION = estado === E_EstadoCausa.CerradoObservacion;
        val.OBSERVACIONES = observacion;
        setIsSendingData(true);
        await DesviacionService.postAccionCierreCausaInmediata(token, val);
        onSave();
      });
    } else if (estado === E_EstadoCausa.Cerrado) {
      ModalConfirmacionCierre(async () => {
        setIsSendingData(true);
        await DesviacionService.postAccionCierreCausaInmediata(token, val);
        onSave();
      });
    } else if (estado === E_EstadoCausa.Rechazada) {
      ModalCausaRechazo(async (motivoRechazo: string) => {
        val.MOTIVO_RECHAZO = motivoRechazo;
        val.RECHAZO = estado === E_EstadoCausa.Rechazada || null;
        setIsSendingData(true);
        await DesviacionService.postAccionCierreCausaInmediata(token, val);
        onSave();
      });
    }
  };
  const validateUploadFile = (value: Partial<IAddDocumentosCausasEvidencias>) => {
    let arrErrors: Array<string> = [];

    if (!refInputDocumento.current?.files) {
      arrErrors.push("ARCHIVO");
    } else {
      if (listDocumentos.filter((d) => d.URL.includes((refInputDocumento.current?.files as FileList)[0].name)).length > 0) {
        arrErrors.push("ARCHIVO_DUPLICADO");

        MySwal.fire({
          html: (
            <div>
              <h3>Archivo "{(refInputDocumento.current?.files)[0].name}" ya se encuentra cargado</h3>
            </div>
          ),
          text: "",
          icon: "error",
          showCloseButton: true,
        });
      }
    }
    return arrErrors.length === 0;
  };
  const handleUploadDocument = async () => {
    let f = is_Test ? {} : ((refInputDocumento.current?.files as FileList)[0] as any);

    let value: Partial<IAddDocumentosCausasEvidencias> = {
      TIPO_CAUSA: "Inmediata",
      ID_DESVIACION: idDesviacion,
      DESCRIPCION: refTxtDescripcionDocumento.current?.value,
      FILE: f,
      ID_CAUSA: selectedAnalisisCausal?.ID,
    };
    if (validateUploadFile(value)) {
      setIsUploadingDocs(true);
      const idCausa = await handleGuardarCausaInmediata(true, false);
      if (idCausa) {
        value.ID_CAUSA = idCausa;
        await DesviacionService.postDocumentoCausaEvidencia(token, value);
        loadDocumentos(idCausa);
      }
      setIsUploadingDocs(false);
    }
  };

  const handleCargarDocumentos = async (pagination?: IPagination) => {
    let params: ISearchDocsCausasEvidencias = pagination
      ? {
          ...pagination,
          ID_CAUSA: selectedAnalisisCausal?.ID,
          ID_DESVIACION: idDesviacion,
        }
      : {
          ID_CAUSA: selectedAnalisisCausal?.ID,
          ID_DESVIACION: idDesviacion,
          ORDENADOPOR: "ID",
          ORIENTACION: "DESC",
          PAGINA: 1,
          PAGINADO: ROW_COUNT,
        };
    let resultDocumentos = is_Test ? { data: docs ?? [], pages: 10 } : await DesviacionService.getDocumentosCausasEvidencias(token, params);
    setListDocumentos(resultDocumentos.data);
    totalPagesListDocumentos.current = resultDocumentos.pages;
  };

  const columnHelperDocumentos = createColumnHelper<IDocumentoDesviacion>();
  let columnsDefDocumentos = [
    columnHelperDocumentos.accessor((row) => row.URL, {
      id: "URL",
      cell: (info: CellContext<IDocumentoDesviacion, string>) => componentValue(getFileName(info.getValue())),
      header: () => component("Nombre Documento"),
      tipo: ITipo_Campo.text,
    } as any),
    columnHelperDocumentos.accessor((row) => row.DESCRIPCION, {
      id: "DESCRIPCION",
      cell: (info: CellContext<IDocumentoDesviacion, string>) => componentValue(info.getValue()),
      header: () => component("Descripción"),
      tipo: ITipo_Campo.text,
    } as any),
    columnHelperDocumentos.accessor((row) => row.ID, {
      id: "VER",
      cell: (info: CellContext<IDocumentoDesviacion, string>) => componentVer(info),
      header: () => component("Ver"),
      tipo: ITipo_Campo.text,
      disableSorting: true,
    } as any),
    columnHelperDocumentos.accessor((row) => row.ID, {
      id: "ELIMINAR",
      cell: (info: CellContext<IDocumentoDesviacion, string>) => componentEliminar(info),
      header: () => component("Eliminar"),
      tipo: ITipo_Campo.text,
      disableSorting: true,
      hide: estadoForm === E_EstadoFormCausaDesviacion.Lectura || estadoForm === E_EstadoFormCausaDesviacion.Cerrar,
    } as any),
  ] as any;

  const error = (err: any) => {
    return arrErrorEmpty.includes(err) && "error";
  };

  return (
    <Offcanvas show={true} onHide={onClose} placement={"end"} className="w-50 modalAgregarCausa">
      <Offcanvas.Header closeButton className="border-bottom">
        <Offcanvas.Title className="m-3 mb-1 colorTit">Causas Inmediatas (Correción)</Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body className="m-3">
        <Row>
          <Col>
            <div className="row mb-2 ajusteInput">
              <button
                hidden={true}
                data-testid="btncerrarcausa"
                onClick={() => {
                  handleCerrarCausa(E_EstadoCausa.CerradoObservacion);
                  handleCerrarCausa(E_EstadoCausa.Cerrado);
                  handleCerrarCausa(E_EstadoCausa.Rechazada);
                  handleUploadDocument();
                  handleGuardarCausaInmediata(false, true);
                  handleGuardarCausaInmediata(false, false);
                  handleGuardarCausaInmediata(true, true);
                  handleGuardarCausaInmediata(true, false);
                  if (addCausaInmediata !== undefined) {
                    validateForm(addCausaInmediata, true);
                  }
                }}></button>
              <button hidden={true} data-testid="btnvalidateform" onClick={() => {}}></button>
              <Col xs="12" md="6" lg="4">
                <span className="text-danger">{estadoForm === E_EstadoFormCausaDesviacion.Agregar && <strong>(*)</strong>}</span>
                <label>Tipo de Causas Inmediatas:</label>
              </Col>
              <Col xs="12" md="6" lg="8">
                {estadoForm === E_EstadoFormCausaDesviacion.Agregar ? (
                  <Select
                    options={comboTCI.map((vcc) => ({
                      value: vcc.ID.toString(),
                      label: vcc.TITULO,
                    }))}
                    className={`${error("ID_TIPO_CAUSA_INMEDIATA")}`}
                    placeholder="Seleccione"
                    isClearable={true}
                    onChange={(e: SingleValue<IComboboxOption>) => {
                      setValComboTCI(e || null);
                      fillComboACS(e?.value);
                    }}
                    defaultValue={
                      selectedAnalisisCausal
                        ? {
                            value: selectedAnalisisCausal.ID_TIPO_CAUSA_INMEDIATA,
                            label: selectedAnalisisCausal.TIPO_CAUSA_INMEDIATA,
                          }
                        : ("" as any)
                    }
                  />
                ) : (
                  <p>{selectedAnalisisCausal?.TIPO_CAUSA_INMEDIATA}</p>
                )}
              </Col>
            </div>
          </Col>
        </Row>
        <Row>
          <Col>
            <div className="row mb-2 ajusteInput">
              <Col xs="12" md="6" lg="4">
                <span className="text-danger">{estadoForm === E_EstadoFormCausaDesviacion.Agregar && <strong>(*)</strong>}</span>
                <label>Acto/Condición subestandar:</label>
              </Col>
              <Col xs="12" md="6" lg="8">
                {estadoForm === E_EstadoFormCausaDesviacion.Agregar ? (
                  <Select
                    options={comboACS.map((vcc) => ({
                      value: vcc.ID as string,
                      label: vcc.TITULO,
                    }))}
                    className={`${error("ID_ACTO_CONDICION_SUBESTANDAR")}`}
                    placeholder="Seleccione"
                    isClearable={true}
                    onChange={(e: SingleValue<IComboboxOption>) => {
                      setvalComboACS(e || null);
                    }}
                    defaultValue={
                      selectedAnalisisCausal
                        ? {
                            value: selectedAnalisisCausal.ID_ACTO_CONDICION_SUBESTANDAR,
                            label: selectedAnalisisCausal.ACTO_CONDICION_SUBESTANDAR,
                          }
                        : ("" as any)
                    }
                  />
                ) : (
                  <p>{selectedAnalisisCausal?.ACTO_CONDICION_SUBESTANDAR}</p>
                )}
              </Col>
            </div>
          </Col>
        </Row>

        <Row>
          <Col>
            <div className="row mb-2 ajusteInput">
              <Col xs="12" md="6" lg="4">
                <span className="text-danger">{estadoForm === E_EstadoFormCausaDesviacion.Agregar && <strong>(*)</strong>}</span>
                <label>Acción:</label>
              </Col>
              <Col xs="12" md="6" lg="8">
                {estadoForm === E_EstadoFormCausaDesviacion.Agregar ? (
                  <span>
                    <textarea
                      ref={refTxtAccion}
                      className={`form-control form-control-sm  ${error("ACCION")} borderGris`}
                      onChange={(e) => {
                        setLenAccion(e.target.value.length);
                      }}
                      defaultValue={selectedAnalisisCausal?.ACCION}
                      rows={4}
                      maxLength={1000}></textarea>
                    <span>{lenAccion}/1000</span>
                  </span>
                ) : (
                  <p>{selectedAnalisisCausal?.ACCION}</p>
                )}
              </Col>
            </div>
          </Col>
        </Row>
        {selectedAnalisisCausal?.ID_ESTADO === E_EstadoCausa.Rechazada ? (
          <Row>
            <Col>
              <div className="row mb-2 ajusteInput">
                <Col xs="12" md="6" lg="4">
                  <label>Motivo rechazo:</label>
                </Col>
                <Col xs="12" md="6" lg="8">
                  <span>{selectedAnalisisCausal.MOTIVO_RECHAZO}</span>
                </Col>
              </div>
            </Col>
          </Row>
        ) : (
          <></>
        )}
        {isFlujoCorto || (
          <Row>
            <Col>
              <div className="row mb-2 ajusteInput">
                <Col xs="12" md="6" lg="4">
                  <span className="text-danger">{estadoForm === E_EstadoFormCausaDesviacion.Agregar && <strong>(*)</strong>}</span>
                  <label>Responsable:</label>
                </Col>
                <Col xs="12" md="6" lg="8">
                  {estadoForm === E_EstadoFormCausaDesviacion.Agregar ? (
                    <UserPicker
                      name={"detectadoPor"}
                      callback={(id, value) => {
                        setValResponsable(value?.shift() || null);
                      }}
                      id={"detectadoPor"}
                      key={"1"}
                      multi={false}
                      disabled={false}
                      className={`${error("RESPONSABLE")} borderColorGris`}
                      defaultValue={
                        selectedAnalisisCausal
                          ? {
                              mail: selectedAnalisisCausal.RESPONSABLE,
                              name: selectedAnalisisCausal.RESPONSABLE_DISPLAY,
                            }
                          : null
                      }
                    />
                  ) : (
                    <p>{selectedAnalisisCausal?.RESPONSABLE_DISPLAY}</p>
                  )}
                </Col>
              </div>
            </Col>
          </Row>
        )}
        <Row>
          <Col>
            <div className="row mb-2 ajusteInput">
              <Col xs="12" md="6" lg="4">
                <label>Fecha de asignación:</label>
              </Col>
              <Col xs="12" md="6" lg="8">
                <p>{moment(selectedAnalisisCausal ? selectedAnalisisCausal.FECHA_ASIGNACION : new Date()).format(dateFormatDiplay)}</p>
              </Col>
            </div>
          </Col>
        </Row>
        {!isFlujoCorto ? (
          <Row>
            <Col>
              <div className="row mb-2 ajusteInput">
                <Col xs="12" md="6" lg="4">
                  <span className="text-danger">{estadoForm === E_EstadoFormCausaDesviacion.Agregar && <strong>(*)</strong>}</span>
                  <label>Fecha hasta:</label>
                </Col>
                <Col xs="12" md="6" lg="8">
                  {estadoForm == E_EstadoFormCausaDesviacion.Agregar ? (
                    <Form.Control
                      ref={refTxtFechaHasta}
                      onChange={(e) => {}}
                      type="date"
                      className={`${error("FECHA_HASTA")} borderColorGris`}
                      defaultValue={selectedAnalisisCausal ? moment(selectedAnalisisCausal?.FECHA_HASTA).format(dateFormatInputReference) : ""}
                    />
                  ) : (
                    <p>{shortDate(selectedAnalisisCausal?.FECHA_HASTA)}</p>
                  )}
                </Col>
              </div>
            </Col>
          </Row>
        ) : (
          <Row>
            <Col>
              <div className="row mb-2 ajusteInput">
                <Col xs="12" md="6" lg="4">
                  <span className="text-danger">{estadoForm === E_EstadoFormCausaDesviacion.Agregar && <strong>(*)</strong>}</span>
                  <label>Fecha de acción realizada:</label>
                </Col>
                <Col xs="12" md="6" lg="8">
                  {estadoForm == E_EstadoFormCausaDesviacion.Agregar ? (
                    <Form.Control
                      ref={refTxtFechaAccionRealizada}
                      onChange={(e) => {}}
                      type="date"
                      className={`${error("FECHA_ACCION_REALIZADA") && "error"} borderColorGris`}
                      defaultValue={
                        selectedAnalisisCausal ? moment(selectedAnalisisCausal?.FECHA_ACCION_REALIZADA).format(dateFormatInputReference) : ""
                      }
                      max={moment().format(dateFormatInputReference)}
                    />
                  ) : (
                    <p>{shortDate(selectedAnalisisCausal?.FECHA_HASTA)}</p>
                  )}
                </Col>
              </div>
            </Col>
          </Row>
        )}
        {estadoForm === E_EstadoFormCausaDesviacion.Agregar && isFlujoCorto && (
          <React.Fragment>
            <Row>
              <div className="card bg-light border p-3 pt-2 mt-2">
                <div className="row ajusteInput">
                  <div className="col-12">
                    <h6>
                      <span className="textSeccion">Adjuntar Evidencia</span>
                    </h6>
                  </div>
                  {isUploadingDocs ? (
                    <Loading />
                  ) : (
                    <div className="col-12">
                      <div className="row mb-2 ajusteInput">
                        <div className="row border m-1 p-1 rounded">
                          <div className="col-sm-12 col-md-12 col-lg-5 mb-2">
                            <label>Descripción</label>
                          </div>
                          <div className="col-sm-12 col-md-12 col-lg-7 mb-2">
                            <textarea className="form-control form-control-sm" rows={3} ref={refTxtDescripcionDocumento}></textarea>
                          </div>
                          <div className="col-sm-12 col-md-12 col-lg-5 mb-2">
                            <label>Adjuntar </label>
                            <span className="text-danger">
                              <small> Peso máximo (50 mb).</small>
                            </span>
                          </div>

                          <div className="col-sm-12 col-md-12 col-lg-7 mb-2">
                            <div className="input-group">
                              <input
                                type="file"
                                className="form-control form-control-sm"
                                id="inputGroupFile04"
                                aria-describedby="inputGroupFileAddon04"
                                aria-label="Seleccionar Archivos"
                                ref={refInputDocumento}
                              />
                              :{" "}
                              <button
                                className="btn btn-primary btn-sm"
                                type="button"
                                id="inputGroupFileAddon04"
                                onClick={() => {
                                  handleUploadDocument();
                                }}
                                disabled={isUploadingDocs}>
                                Subir
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
                <Row>
                  <Col>
                    <AdminListaPagination
                      defaultSortBy="ID"
                      sortDirection="DESC"
                      totalPages={totalPagesListDocumentos}
                      callback={async (pagination) => {
                        await handleCargarDocumentos(pagination);
                      }}
                      reload={async () => {
                        await handleCargarDocumentos();
                      }}
                      columnsDef={columnsDefDocumentos}
                      data={listDocumentos || []}
                      hideAdd={true}
                      hideExport={true}
                      hideReload={true}
                    />
                  </Col>
                </Row>
              </div>
            </Row>
          </React.Fragment>
        )}

        {isVistaDetallada && (
          <React.Fragment>
            <Row>
              <Col>
                <div className="row mb-2 ajusteInput">
                  <Col xs="12" md="6" lg="4">
                    <span className="text-danger">{estadoForm === E_EstadoFormCausaDesviacion.Agregar && <strong>(*)</strong>}</span>
                    <label>Fecha Acción Realizada:</label>
                  </Col>
                  <Col xs="12" md="6" lg="8">
                    <label>
                      {selectedAnalisisCausal?.FECHA_ACCION_REALIZADA
                        ? moment(selectedAnalisisCausal?.FECHA_ACCION_REALIZADA).format(dateFormatDiplay)
                        : ""}
                    </label>
                  </Col>
                </div>
              </Col>
            </Row>
            <Row>
              <Col>
                <div className="row mb-2 ajusteInput">
                  <Col xs="12" md="6" lg="4">
                    <span className="text-danger">{estadoForm === E_EstadoFormCausaDesviacion.Agregar && <strong>(*)</strong>}</span>
                    <label>Fecha Ingreso Acción Realizada:</label>
                  </Col>
                  <Col xs="12" md="6" lg="8">
                    <label>
                      {selectedAnalisisCausal?.FECHA_INGRESO_ACCION_REALIZADA
                        ? moment(selectedAnalisisCausal?.FECHA_INGRESO_ACCION_REALIZADA).format(dateFormatDiplay)
                        : ""}
                    </label>
                  </Col>
                </div>
              </Col>
            </Row>
          </React.Fragment>
        )}
        {selectedAnalisisCausal?.ID_ESTADO === E_EstadoCausa.Rechazada && (
          <React.Fragment>
            <Row>
              <Col>
                <div className="row mb-2 ajusteInput">
                  <Col xs="12" md="6" lg="4">
                    <span className="text-danger">{estadoForm === E_EstadoFormCausaDesviacion.Agregar && <strong>(*)</strong>}</span>
                    <label>Motivo Rechazo:</label>
                  </Col>
                  <Col xs="12" md="6" lg="8">
                    <label>{selectedAnalisisCausal?.MOTIVO_RECHAZO}</label>
                  </Col>
                </div>
              </Col>
            </Row>
          </React.Fragment>
        )}
        {selectedAnalisisCausal?.ID_ESTADO === E_EstadoCausa.CerradoObservacion && (
          <React.Fragment>
            <Row>
              <Col>
                <div className="row mb-2 ajusteInput">
                  <Col xs="12" md="6" lg="4">
                    <span className="text-danger">{estadoForm === E_EstadoFormCausaDesviacion.Agregar && <strong>(*)</strong>}</span>
                    <label>Observación:</label>
                  </Col>
                  <Col xs="12" md="6" lg="8">
                    <label>{selectedAnalisisCausal?.OBSERVACIONES}</label>
                  </Col>
                </div>
              </Col>
            </Row>
          </React.Fragment>
        )}
        {((isVistaDetallada && isFlujoCorto) || (estadoForm !== E_EstadoFormCausaDesviacion.Agregar && isVistaDetallada)) && (
          <React.Fragment>
            <Row>
              <Col>
                <div className="row mb-2 ajusteInput">
                  <Col xs="12" md="6" lg="4">
                    <span className="text-danger">{estadoForm === E_EstadoFormCausaDesviacion.Agregar && <strong>(*)</strong>}</span>
                    <span className="textSeccion">Carga Documentos Adjuntos:</span>
                  </Col>
                </div>
              </Col>
            </Row>
            <Row>
              <Col>
                <AdminListaPagination
                  defaultSortBy="ID"
                  sortDirection="DESC"
                  totalPages={totalPagesListDocumentos}
                  callback={async (pagination) => {
                    await handleCargarDocumentos(pagination);
                  }}
                  reload={async () => {
                    await handleCargarDocumentos();
                  }}
                  columnsDef={columnsDefDocumentos}
                  data={listDocumentos || []}
                  hideAdd={true}
                  hideExport={true}
                  hideReload={true}
                />
              </Col>
            </Row>
          </React.Fragment>
        )}
        <Row className="mb-2 ajusteInput mt-4">
          {isSendingData ? (
            <Loading />
          ) : (
            <Col xs="12" md="12" lg="12" className="text-center">
              {estadoForm === E_EstadoFormCausaDesviacion.Lectura || (
                <span>
                  {estadoForm === E_EstadoFormCausaDesviacion.Agregar && (
                    <button
                      className="btn btn-sm btn-primary me-2"
                      onClick={() => {
                        handleGuardarCausaInmediata();
                      }}
                      disabled={isSendingData}>
                      Guardar
                    </button>
                  )}
                  {isFlujoCorto && estadoForm === E_EstadoFormCausaDesviacion.Agregar && (
                    <button
                      className="btn btn-sm btn-primary me-2"
                      onClick={() => {
                        handleGuardarCausaInmediata(false, true);
                      }}
                      disabled={isSendingData}>
                      Acción Realizada
                    </button>
                  )}
                  {estadoForm === E_EstadoFormCausaDesviacion.Cerrar && renderEstadoForm() ? (
                    <span>
                      <button
                        className="btn btn-sm btn-primary me-2"
                        onClick={() => {
                          handleCerrarCausa(E_EstadoCausa.Cerrado);
                        }}
                        disabled={isSendingData}>
                        Cerrar
                      </button>
                      <button
                        className="btn btn-sm btn-primary me-2"
                        onClick={() => {
                          handleCerrarCausa(E_EstadoCausa.CerradoObservacion);
                        }}
                        disabled={isSendingData}>
                        Cerrar con Observaciones
                      </button>
                      <button
                        className="btn btn-sm btn-primary me-2"
                        onClick={() => {
                          handleCerrarCausa(E_EstadoCausa.Rechazada);
                        }}
                        hidden={selectedAnalisisCausal?.MOTIVO_RECHAZO !== null}
                        disabled={isSendingData}>
                        Rechazar
                      </button>
                    </span>
                  ) : (
                    <></>
                  )}
                </span>
              )}
              <button
                className="btn btn-sm btn-primary me-2"
                onClick={() => {
                  onClose();
                }}
                disabled={isSendingData}>
                Volver
              </button>
            </Col>
          )}
        </Row>
      </Offcanvas.Body>
    </Offcanvas>
  );
}
